export const environment = {
	production: false,
	url: "https://api-motor.policystreet.app",
  crmUrl: "https://api-crm.policystreet.app",
  googleTagId: "",
};
